define(
    'modules/tooltip',[
        'jquery',

        'utils/bind-manager',
        'settings'
    ],

    function ($, BindMng, settings) {
        /**
         * @class Tooltip
         */
        return (function () {
            /**
             * Tooltip constructor
             *
             * @param el The element which the tooltip should appear above
             * @param text Tooltip text
             * @constructor
             */
            function Tooltip(el, text) {
                this.el = el;
                this.text = text;
                this.tooltip = $('<div class="tooltip">' + text + '</div>').appendTo('body');
                this.visible = false;
            }

            /**
             * @method show
             */
            Tooltip.prototype.show = function () {
                var x = this.el.offset().left + (this.el.outerWidth() / 2) - (this.tooltip.outerWidth() / 2),
                    y = this.el.offset().top - this.tooltip.outerHeight() - 10,
                    _this = this;

                this.tooltip.css({
                    'left': x,
                    'top': y,
                    'z-index': 102
                });

                setTimeout(function () {
                    _this.tooltip.addClass('tooltip--pre-show');

                    setTimeout(function () {
                        _this.tooltip.addClass('tooltip--show');
                        _this.visible = true;
                    }, 0);
                }, 0);
            };

            /**
             * @method hide
             */
            Tooltip.prototype.hide = function () {
                var _this = this;

                window.clearTimeout(this.hideTimeout);

                if (!this.visible) return;
                this.tooltip.removeClass('tooltip--show');
                setTimeout(function () {
                    _this.tooltip.removeClass('tooltip--pre-show');
                    _this.visible = false;
                }, settings.transitionTime);
            };

            /**
             * @method destroy
             */
            Tooltip.prototype.destroy = function (root, event) {
                var _this = this;

                $(root).on(event, function () {
                    _this.tooltip.remove();
                    _this.visible = false;
                });
            };

            /**
             * Binds on hover with a delay so it doesn't show too frequently on pages with lots of
             * tooltips.
             */
            Tooltip.prototype.init = function () {
                var _this = this;

                var timer;
                this.el.hover(
                    function () {
                        timer = setTimeout(function () {
                            if (!_this.visible) {
                                _this.show();
                            }
                        }, 600);
                    },
                    function () {
                        clearTimeout(timer);
                        _this.hide();
                    }
                );
            };

            return Tooltip;
        })();
    }
);
